import { Route, Routes } from 'react-router-dom';

import AddService from 'pages/AddService';
import AddServiceOptional from 'pages/AddServiceOptional';
import AdminSearch from 'pages/AdminSearch';
import AdminSignup from 'pages/AdminSignup';
import Appointments from 'pages/Appointments';
import AvatarUpload from 'pages/AvatarUpload';
import BusinessHours from 'pages/BusinessHours';
import BusinessInformation from 'pages/BusinessInformation';
import FinishSignupMFA from 'pages/FinishSignupMFA';
import Home from 'pages/Home';
import Login from 'pages/Login';
import LoginSms from 'pages/LoginSms';
import MFA from 'pages/MFA';
import NewPassword from 'pages/NewPassword';
import NotFound from 'pages/NotFound';
import PasswordReset from 'pages/PasswordReset';
import PaymentHistory from 'pages/PaymentHistory';
import PetProfile from 'pages/PetProfile';
import PhoneVerification from 'pages/PhoneVerification';
import { Privacy } from 'pages/Privacy';
import Profile from 'pages/Profile';
import Signup from 'pages/Signup';
import Team from 'pages/Team';
import TodaysAppointments from 'pages/TodaysAppointments';

import PrivateRoute from './PrivateRoute';

const getRoutes = () => (
  <Routes>
    <Route path="*" element={<NotFound />} />
    <Route path="/privacy" element={<Privacy />} />

    {/* Admin */}
    <Route
      path="/admin/_signup"
      element={
        <PrivateRoute adminCheck>
          <AdminSignup />
        </PrivateRoute>
      }
    />
    <Route
      path="search-provider"
      element={
        <PrivateRoute adminCheck>
          <AdminSearch />
        </PrivateRoute>
      }
    />

    {/* Signup/Login  */}
    <Route path="/" element={<Home />} />
    <Route path="/signup" element={<Signup />} />
    <Route path="/login" element={<Login />} />
    <Route path="/login-sms" element={<LoginSms />} />
    <Route path="/forgot-password" element={<PasswordReset />} />
    <Route path="/password-reset/:code" element={<NewPassword />} />
    <Route path="/signup-verification" element={<MFA />} />

    {/* Phone verification */}
    <Route path="signup/phone-verification" element={<PhoneVerification />} />
    <Route path="signup/mfa" element={<FinishSignupMFA />} />

    {/* Provider setup */}
    <Route
      path="/signup-2"
      element={
        <PrivateRoute>
          <BusinessInformation />
        </PrivateRoute>
      }
    />
    <Route
      path="/signup-3"
      element={
        <PrivateRoute>
          <BusinessHours />
        </PrivateRoute>
      }
    />
    <Route
      path="/signup-4"
      element={
        <PrivateRoute>
          <AvatarUpload />
        </PrivateRoute>
      }
    />

    {/* Services */}
    <Route
      path="/add-service"
      element={
        <PrivateRoute>
          <AddService />
        </PrivateRoute>
      }
    />
    <Route
      path="/add-service/optional"
      element={
        <PrivateRoute>
          <AddServiceOptional />
        </PrivateRoute>
      }
    />

    {/* Provider */}
    <Route
      path="/services"
      element={
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      }
    >
      <Route
        path=":providerSlug"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
    </Route>
    <Route
      path="/appointments"
      element={
        <PrivateRoute>
          <Appointments />
        </PrivateRoute>
      }
    >
      <Route
        path=":filter"
        element={
          <PrivateRoute>
            <Appointments />
          </PrivateRoute>
        }
      />
    </Route>
    <Route
      path="/pet-profile/:petId"
      element={
        <PrivateRoute>
          <PetProfile />
        </PrivateRoute>
      }
    />
    <Route
      path="payment-history/:page"
      element={
        <PrivateRoute>
          <PaymentHistory />
        </PrivateRoute>
      }
    />
    <Route
      path="/team"
      element={
        <PrivateRoute>
          <Team />
        </PrivateRoute>
      }
    />
    <Route
      path="/today"
      element={
        <PrivateRoute>
          <TodaysAppointments />
        </PrivateRoute>
      }
    />
  </Routes>
);

export default getRoutes;
